export default "__VITE_ASSET__NqP6giez__"